<div id="scroll-container" class="scroll-container" [ngClass]="{ 'h-100': !ticket.isTicketCanBeReplied }">
    <div style="height: fit-content">
        @if (ticket.initialPageUrl) {
            <div>
                <span>
                    {{ 'Initial page url:' | translate }}
                    <a [href]="ticket.initialPageUrl" target="_blank" class="link">
                        {{ ticket.initialPageUrl }}
                    </a>
                </span>
            </div>
        }

        <div [hidden]="!ticket.latestPageUrl">
            <span id="latest-page-url" [appHighlightOnChange]="ticket.latestPageUrl" [highlightContext]="ticket.id">
                {{ 'Latest page url:' | translate }}
                <a [href]="ticket.latestPageUrl" target="_blank" rel="noopener noreferrer" class="link">
                    {{ ticket.latestPageUrl }}
                </a>
                @if (ticket.latestPageUrlUpdatedAt) {
                    <time class="small ms-2" [attr.datetime]="ticket.latestPageUrlUpdatedAt">
                        {{ ticket.latestPageUrlUpdatedAt | date: 'dd.MM.yyyy HH:mm:ss' }}
                    </time>
                }
            </span>
        </div>

        @if (ticket.firstMessageCreatorIpAddress) {
            <p>{{ ("Client's IP address:" | translate) + ' ' + ticket.firstMessageCreatorIpAddress }}</p>
        }

        @if (ticket.fields.length > 0) {
            <app-fields [ticket]="ticket"></app-fields>
        }

        <app-integration-block class="integration-block print-hidden" [ticket]="ticket"></app-integration-block>

        <div class="replies-block-chat">
            <div class="replies-container">
                <div
                    class="print-hidden"
                    infiniteScroll
                    (scrolledUp)="loadMore()"
                    [infiniteScrollDistance]="2"
                    [infiniteScrollUpDistance]="1.5"
                    [infiniteScrollThrottle]="50"
                    [infiniteScrollContainer]="'#scroll-container'"
                    [fromRoot]="true">
                    @for (reply of chatRepliesLoaded; track reply) {
                        <app-reply-chat
                            id="reply-id-{{ reply?.id }}"
                            [reply]="reply"
                            [ticket]="ticket"
                            [parent]="parent"></app-reply-chat>
                    } @empty {
                        <div class="text-center text-light py-5" role="status">
                            <sb-inline-svg
                                class="icon mb-2"
                                aria-hidden="true"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Chat icon.svg'">
                            </sb-inline-svg>
                            <p class="mb-0" translate>No messages yet</p>
                        </div>
                    }
                </div>

                @if (threadFilterService.isPrinting) {
                    <div class="ticket-thread-for-printing" style="display: none">
                        @for (reply of chatReplies; track reply) {
                            <app-reply-chat
                                id="reply-id-{{ reply?.id }}"
                                [reply]="reply"
                                [ticket]="ticket"
                                [parent]="parent"></app-reply-chat>
                        }
                    </div>
                }

                @if (
                    ticket.isTicketCanBeReplied &&
                    ticket.firstMessageCreator.isAnonymous &&
                    !ticket.isAssignedToBot &&
                    parent.isCustomerOnline
                ) {
                    <div class="text-end">
                        <span translate>This user is anonymous.</span>&nbsp;
                        <a (click)="triggerUserIdentification()" translate> Push authentication page to chat here. </a>
                    </div>
                }

                <div id="typing-message-block">
                    @for (typingInfo of typingInfos; track typingInfo) {
                        <div class="user-typing">
                            {{ typingInfo.user.name }} <span translate>is typing</span>
                            <span class="small-size loader-ball"></span>
                        </div>
                    }

                    @if (parent.isSendingReply) {
                        <div class="user-typing text-center">
                            <span class="small-size loader-ball"></span>
                        </div>
                    }
                </div>
            </div>
        </div>

        @if (ticket.isTicketCanBeReplied && ticket.suggestions.length) {
            <app-suggestions [suggestions]="ticket.suggestions"></app-suggestions>
        }
    </div>
</div>

@if (ticket.isTicketCanBeReplied) {
    <div
        id="ticket-thread-chat-new-reply"
        class="new-reply ticket-message print-hidden expanded"
        [ngClass]="{ pointer: ticket.source !== parent.ticketSourceEnum.email }"
        (window:resize)="updateContentHeight()">
        @if (parent.isSendingReply) {
            <div class="ticket-blocker"></div>
        }

        <div>
            <div class="full-reply-form d-flex flex-row">
                <sb-user-avatar [user]="parent.user" [isNeedTooltip]="false" style="box-shadow: 0 0 5px 5px white">
                </sb-user-avatar>

                <div class="flex-fill">
                    <div class="smile-field-container" id="new-reply">
                        @if (
                            !commonDataService.isOneTime &&
                            replyTemplateService.allReplyTemplates.length &&
                            parent.quillEditors['newReply']
                        ) {
                            <sb-quill-reply-templates
                                [isTextContent]="true"
                                [quillEditor]="parent.quillEditors['newReply']"
                                [reply]="ticket.constraints.areReplyAttachmentsAllowed ? newReply : null">
                            </sb-quill-reply-templates>
                        }

                        <quill-editor
                            id="ticket-thread-chat-editor"
                            class="new-reply-editor"
                            [(ngModel)]="newReply.message.html"
                            (onEditorCreated)="parent.onEditorCreated($event, 'newReply'); updateContentHeight()"
                            (onContentChanged)="onReplyChanged($event, newReply, true)"
                            [modules]="quillConfig"
                            [formats]="['emoji']"
                            placeholder="{{ 'Write a reply' | translate }}">
                        </quill-editor>

                        <sb-quill-emoji-picker
                            (updateQuillSelection)="parent.updateQuillSelection(parent.quillEditors['newReply'])"
                            (emojiSelect)="
                                parent.replyTemplateManagerService.chooseReplyTemplate({
                                    $event: $event.$event,
                                    templateText: $event.emoji,
                                    quillEditor: parent.quillEditors['newReply'],
                                    quillRange: parent.quillRange,
                                    isSmile: true,
                                })
                            ">
                        </sb-quill-emoji-picker>
                    </div>

                    <div class="content-attachments-wrapper">
                        @for (
                            attachment of newReply.attachments
                                | filterContentAttachments: true : newReply.attachments.length;
                            track attachment;
                            let idx = $index
                        ) {
                            <div class="content-attachments-block">
                                <button
                                    type="button"
                                    class="btn btn-icon btn-close btn-transparent"
                                    aria-label="Close"
                                    (click)="deleteGifAttachment(attachment)">
                                    <sb-inline-svg
                                        class="icon icon-close"
                                        aria-label="My icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                                    </sb-inline-svg>
                                </button>
                                <sb-file-view
                                    [isFilePreviewInModal]="true"
                                    [attachment]="attachment"
                                    [permalink]="ticket.permalink">
                                </sb-file-view>
                            </div>
                        }
                    </div>

                    @if (
                        (newReply.attachments | filterContentAttachments: false : newReply.attachments.length).length
                    ) {
                        <div class="attachments-block">
                            @for (attachment of newReply.attachments; track attachment; let idx = $index) {
                                @if (!attachment.isContentPart) {
                                    <sb-file-preview
                                        class="file-container"
                                        [attachment]="attachment"
                                        [fileIndex]="idx"
                                        [canBeRemoved]="true"
                                        [permalink]="ticket.permalink"
                                        [attachments]="newReply.attachments">
                                    </sb-file-preview>
                                }
                            }
                            <div class="clearfix"></div>
                        </div>
                    }
                </div>
            </div>

            <div class="top10">
                <div class="clearfix"></div>

                <div class="buttons-panel text-end">
                    @if (
                        ticket.constraints.isGifReplySupported &&
                        !(newReply.attachments | filterContentAttachments: true : newReply.attachments.length).length
                    ) {
                        <sb-giphy-picker (add)="addGifAttachment($event)" [isDisabled]="parent.isSendingReply">
                        </sb-giphy-picker>
                    }

                    @if (!commonDataService.isOneTime) {
                        <button
                            class="btn btn-icon"
                            (click)="
                                parent.openReplyTemplatesModal(
                                    $event,
                                    parent.quillEditors['newReply'],
                                    ticket.constraints.areReplyAttachmentsAllowed ? newReply : null
                                )
                            "
                            tooltip="{{ 'Insert a saved template' | translate }}"
                            container="body">
                            <sb-inline-svg
                                class="icon"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'">
                            </sb-inline-svg>
                        </button>
                    }

                    <button
                        id="btn-signature"
                        class="btn btn-icon"
                        (click)="parent.setSignature(newReply, null, $event, false)"
                        [disabled]="newReply.isSendingReply"
                        tooltip="{{ 'Signature' | translate }}"
                        container="body">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'">
                        </sb-inline-svg>
                    </button>

                    @if (ticket.isEditable && ticket.constraints.areReplyAttachmentsAllowed) {
                        <button
                            class="btn btn-icon"
                            (click)="
                                parent.openAttachmentsModal(
                                    newReply.attachments,
                                    newReply.attachments.length,
                                    ticket.constraints.maxReplyAttachmentsCount
                                )
                            "
                            tooltip="{{ 'Attachments' | translate }}">
                            <sb-inline-svg
                                class="icon"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                            </sb-inline-svg>
                        </button>
                    }

                    <ng-template #infoPopover>
                        <div
                            class="popover-wrapper"
                            (mouseleave)="hideSendButtonConfigPopover()"
                            (mouseenter)="showSendButtonConfigPopover()">
                            <div class="radio">
                                <label class="radio-label radio-label--size-small">
                                    <p class="mb-0"><strong>Enter</strong> — {{ 'send reply' | translate }}</p>
                                    <p><strong>Shift+Enter</strong> — {{ 'new line' | translate }}</p>
                                    <input type="radio" [(ngModel)]="isSendingByEnterNewValue" [value]="true" />
                                    <span class="radio-checkmark"></span>
                                </label>
                            </div>
                            <div class="radio">
                                <label class="radio-label radio-label--size-small mb-0">
                                    <p class="mb-0"><strong>Ctrl+Enter</strong> — {{ 'send reply' | translate }}</p>
                                    <p class="mb-0"><strong>Enter</strong> — {{ 'new line' | translate }}</p>
                                    <input type="radio" [(ngModel)]="isSendingByEnterNewValue" [value]="false" />
                                    <span class="radio-checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </ng-template>

                    @if (ticket.constraints.isReplyByEmailForChatsAllowed) {
                        <button
                            class="btn"
                            [disabled]="
                                (newReply.message
                                    | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false) ||
                                parent.isSendingReply
                            "
                            (click)="
                                newReply.isNeedToBeSentByEmail = true;
                                isOnlyAutoSignatureSet && addAutoSignature();
                                parent.addReply(newReply)
                            "
                            translate>
                            send as email
                        </button>
                    }

                    @if (!commonDataService.isOneTime) {
                        <button
                            class="btn btn-outline"
                            [disabled]="
                                (newReply.message
                                    | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false) ||
                                parent.isSendingReply
                            "
                            (click)="
                                newReply.isNeedToBeSentByEmail = false;
                                hideSendButtonConfigPopover();
                                isOnlyAutoSignatureSet && addAutoSignature();
                                parent.addReply(newReply)
                            "
                            [popover]="infoPopover"
                            triggers=""
                            #sendButtonConfigPopover="bs-popover"
                            (mouseenter)="showSendButtonConfigPopover()"
                            (mouseleave)="hideSendButtonConfigPopover()"
                            (onHidden)="updateChatSendingByEnter()"
                            translate>
                            send
                        </button>

                        @if (ticket.source !== ticketSourceEnum.chat) {
                            <button
                                class="btn btn-outline"
                                [disabled]="
                                    newReply.message
                                        | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false
                                "
                                (click)="
                                    newReply.isNeedToBeSentByEmail = false;
                                    isOnlyAutoSignatureSet && addAutoSignature();
                                    parent.addReply(newReply, false, true)
                                "
                                translate>
                                send and close
                            </button>
                        }
                    }

                    @if (commonDataService.isOneTime) {
                        <button
                            class="btn"
                            [disabled]="
                                (newReply.message
                                    | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false) ||
                                parent.isSendingReply
                            "
                            (click)="
                                newReply.isNeedToBeSentByEmail = false;
                                isOnlyAutoSignatureSet && addAutoSignature();
                                parent.addReply(newReply)
                            "
                            translate>
                            send
                        </button>
                    }
                </div>
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
}
